import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from 'vue-i18n';
import i18n from './message';

Vue.use(VueAxios, axios)
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  VueI18n,
  i18n,
  render: h => h(App)
}).$mount('#app')


//Redirect When Token Expire
axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  // console.log(error.response.data)
  if (error.response && error.response.status === 401) {
    //add your code
    // alert("Time Out | Token Problem !");
    if (this.shared_token_status == "1" && this.url_callback != null) {
      // window.location = url_callback
      window.location.replace(this.url_callback);
      store.commit('logout')
    } else {
      // window.location.href = "/";
      const url = location.origin + "/login";
      window.location.replace(url);
      store.commit('logout')
    }
    // store.commit('logout')
    // router.push('/login')
  }
  if (error.response && error.response.data) {
    //add your code
    // console.log("403");
    return Promise.reject(error.response.data);
  }
  return Promise.reject(error.message);
});
